export const GET_CUSTOMER = 'dashboard/customer/GET_CUSTOMER';
export const GET_CUSTOMER_SUCCESS = 'dashboard/customer/GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAILED = 'dashboard/customer/GET_CUSTOMER_FAILED';

export const GET_CUSTOMER_REQUIRED_DETAILS =
  'dashboard/customer/GET_CUSTOMER_REQUIRED_DETAILS';
export const GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS =
  'dashboard/customer/GET_CUSTOMER_REQUIRED_DETAILS_SUCCESS';
export const GET_CUSTOMER_REQUIRED_DETAILS_FAILED =
  'dashboard/customer/GET_CUSTOMER_REQUIRED_DETAILS_FAILED';

export const UPDATE_CUSTOMER = 'dashboard/customer/UPDATE_CUSTOMER';
export const UPDATE_CUSTOMER_SUCCESS =
  'dashboard/customer/UPDATE_CUSTOMER_SUCCESS';
export const UPDATE_CUSTOMER_BOOKING_DELIVERIES =
  'dashboard/customer/UPDATE_CUSTOMER_BOOKING_DELIVERIES';
export const UPDATE_CUSTOMER_BOOKING_DELIVERIES_SUCCESS =
  'dashboard/customer/UPDATE_CUSTOMER_BOOKING_DELIVERIES_SUCCESS';

export const GET_ADDITIONAL_CUSTOMER =
  'dashboard/customer/GET_ADDITIONAL_CUSTOMER';
export const GET_ADDITIONAL_CUSTOMER_SUCCESS =
  'dashboard/customer/GET_ADDITIONAL_CUSTOMER_SUCCESS';
export const GET_ADDITIONAL_CUSTOMER_FAILED =
  'dashboard/customer/GET_ADDITIONAL_CUSTOMER_FAILED';

export const UPDATE_ADDITIONAL_CUSTOMER =
  'dashboard/customer/UPDATE_ADDITIONAL_CUSTOMER';
export const UPDATE_ADDITIONAL_CUSTOMER_SUCCESS =
  'dashboard/customer/UPDATE_ADDITIONAL_CUSTOMER_SUCCESS';
